import type {StateCreator} from 'zustand'

export type DiffFilterState = {
  filterText: string
  fileExtensions: Record<string, number>
  activeChangeGroupId: number | undefined
  unselectedFileExtensions: Set<string>
  showDeletedFiles?: boolean
  showOnlyManifestFiles?: boolean
  showOnlyOwnedFiles?: boolean
  showVendoredFiles?: boolean
  showViewedFiles?: boolean
}

export type DiffFilterSlice = {
  diffFilter: {
    state: DiffFilterState
    filtersInteractedWith: boolean
  }
  diffFilterActions: {
    updateDiffFilter: (filterState: Partial<DiffFilterState>, userInteracted?: boolean) => void
    clearAllFilters: () => void
  }
}

export const createDiffFilterSlice =
  (): StateCreator<DiffFilterSlice, [['zustand/devtools', never]], [], DiffFilterSlice> => (set, get) => ({
    diffFilter: {
      state: {
        activeChangeGroupId: undefined,
        filterText: '',
        fileExtensions: {},
        unselectedFileExtensions: new Set(),
        showDeletedFiles: true,
        showOnlyManifestFiles: false,
        showOnlyOwnedFiles: false,
        showVendoredFiles: true,
        showViewedFiles: true,
      },
      filtersInteractedWith: false,
    },
    diffFilterActions: {
      updateDiffFilter: (updatedDiffFilterState: Partial<DiffFilterState>, userInteracted?: boolean) => {
        set(
          {
            diffFilter: {
              ...get().diffFilter,
              state: {
                ...get().diffFilter.state,
                ...updatedDiffFilterState,
              },
              filtersInteractedWith: get().diffFilter.filtersInteractedWith || !!userInteracted,
            },
          },
          undefined,
          'updateFilters',
        )
      },
      clearAllFilters: () => {
        set(
          {
            diffFilter: {
              ...get().diffFilter,
              state: {
                ...get().diffFilter.state,
                filterText: '',
                unselectedFileExtensions: new Set(),
                showOnlyOwnedFiles: false,
                showDeletedFiles: true,
                showOnlyManifestFiles: false,
                showVendoredFiles: true,
                showViewedFiles: true,
              },
              filtersInteractedWith: true,
            },
          },
          undefined,
          'clearAllFilters',
        )
      },
    },
  })
